import { Component, OnChanges, SimpleChanges, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { ImportserialService } from '../../services/importserial.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-revert-serial-import',
  templateUrl: './revert-serial-import.component.html',
  styleUrl: './revert-serial-import.component.scss'
})
export class RevertSerialImportComponent implements OnChanges, OnDestroy {

  @Input() typeId: number = 0;
  @Output() onRevert = new EventEmitter();
  totalRecord: number = 0;
  first: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  data = [];
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private appMainService: AppMainService, private importService: ImportserialService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
      this.pageNumber = 1;
      this.loadImportedList(this.pageNumber, this.pageSize, this.typeId)
  }

  loadImportedList(pageNumber: number, pageSize: number, typeId: number) {
    this.appMainService.isShowSpinner("loadData");
    this.importService.getImportDataList(pageNumber, pageSize, typeId).pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (res) => {
          let { importList, headers } = res;
          importList = importList ?? [];
          headers = headers ?? [];
          this.data = importList;
          this.totalRecord = headers["TotalCount"];
          this.appMainService.isHideSpinner("loadData");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadData");
        },
      });
  }

  getData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.first = event.first;
    this.loadImportedList(this.pageNumber, this.pageSize, this.typeId);
  }



  rollBackImport(importData) {
    this.confirmationService.confirm({
      message: "Are you sure you want to revert this import?",
      header: "Alert Warning",
      icon: "pi pi-info-circle",
      accept: () => {
        this.appMainService.isShowSpinner("rollBackImport");
        this.importService.rollBackImportFile(importData.id, this.typeId).pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe({
            next: (res) => {
              this.onRevert.emit();
              this.appMainService.isHideSpinner("rollBackImport");
            },
            error: (error) => {
              this.appMainService.isHideSpinner("rollBackImport");
            },
          });
      },
      reject: () => { },
    });

  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

}
